import { EFinancingProgram } from '@if/core/types'
import { FinancingProgramConfigs } from '@src/types/Constants'

export const merchantSupportsInviteMessages = (supportedPrograms: EFinancingProgram[]): boolean => {
  return supportedPrograms.some((program) => {
    const programConfig = FinancingProgramConfigs[program]
    return programConfig?.supportsInviteMessages === true
  })
}
